var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.02 0 0 228.996 0 512c0 282.98 228.994 512 512 512 282.98 0 512-228.993 512-512C1024 229.02 795.006 0 512 0zm0 955.735C267.326 955.735 68.266 756.677 68.266 512S267.326 68.268 512 68.268 955.734 267.327 955.734 512 756.674 955.736 512 955.736zM560.272 512l159.972-159.973c13.33-13.328 13.33-34.942 0-48.272-13.328-13.328-34.942-13.328-48.272 0L512 463.73 352.028 303.754c-13.328-13.33-34.938-13.33-48.272 0-13.33 13.328-13.33 34.942 0 48.272L463.728 512 303.756 671.976c-13.33 13.328-13.33 34.942 0 48.272s34.942 13.33 48.272 0L512 560.273l159.972 159.974c13.326 13.328 34.938 13.332 48.272 0 13.33-13.328 13.33-34.942 0-48.272L560.272 512z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.627817e35d015fd73914511a4394c931.svg";
export { ForwardRef as ReactComponent };